import { render, staticRenderFns } from "./SmsAdminView.vue?vue&type=template&id=49a7d9d1&scoped=true&"
import script from "./SmsAdminView.vue?vue&type=script&lang=js&"
export * from "./SmsAdminView.vue?vue&type=script&lang=js&"
import style0 from "./SmsAdminView.vue?vue&type=style&index=0&id=49a7d9d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a7d9d1",
  null
  
)

export default component.exports